export const vlan = {
  iptv_select: "iptv_select",
  vlan_select: "vlan_select",
  enable_vlan_id: "enable_vlan_id",
  vlan_id_input: "vlan_id_input",
  vlan_type: "vlan_type",
  add: "add",
  edit: "edit",
  delete: "delete",
};

export default vlan;
